import { useEffect, useState } from "react";

export const useClientList = (userDetails) => {
  const [clientlist, setClientlist] = useState(null);
  const [SelectedClient, setSelectedClient] = useState(null);
  const fetchClientList = async () => {
    try {
      const formData = new FormData();
      formData.append("sub", userDetails?.sub);
      formData.append("client_id", userDetails?.clientid);
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getclientlist.php`;
      const response = await fetch(apiUrl, { method: "POST", body: formData });
      const result = await response.json();

      if (result.message === "Records fetched successfully") {
        // clone to avoid reference mutation
        const dataClone = structuredClone(result.data);
        setClientlist(dataClone);
      }
    } catch (err) {
      console.error("Error fetching client list:", err);
    }
  };

  useEffect(() => {
    fetchClientList();
  }, [userDetails?.sub]);

  useEffect(() => {
    if (SelectedClient) {
      Object.freeze(SelectedClient);
      Object.freeze(SelectedClient.tic_approval);
    }
  }, [SelectedClient]);
  // console.log("BEFORE RENDER SELECTEDCLIENT", JSON.stringify(SelectedClient));

  useEffect(() => {
    if (clientlist) {
      // console.log("CLIENTLIST RAW", JSON.stringify(clientlist));
    }
  }, [clientlist]);

  return {
    clientlist,
    setClientlist,
    SelectedClient,
    setSelectedClient,
    refreshClientList: fetchClientList,
  };
};

// import { useEffect, useState } from "react";
// let cachedClientlist = null;

// export const useClientList = (userDetails) => {
//   const [clientlist, setClientlist] = useState(cachedClientlist);
//   const [SelectedClient, setSelectedClient] = useState(null);

//   const fetchClientList = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("sub", userDetails?.sub);
//       const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getclientlist.php`;
//       const response = await fetch(apiUrl, { method: "POST", body: formData });
//       const result = await response.json();

//       if (result.message === "Records fetched successfully") {
//         cachedClientlist = result.data;
//         setClientlist(result.data);
//       }
//     } catch (err) {
//       console.error("Error fetching client list:", err);
//     }
//   };

//   useEffect(() => {
//     if (cachedClientlist) {
//       setClientlist(cachedClientlist);
//       return;
//     }
//     fetchClientList();
//   }, [userDetails?.sub]);

//   return {
//     clientlist,
//     setClientlist,
//     SelectedClient,
//     setSelectedClient,
//     refreshClientList: fetchClientList,
//   };
// };
